import { CQAppConstant } from "app-constants";
import { SFConnection } from "./sf-connector";

// Cache for the managed package version ID
let cachedManagedPkgVersionId: string;

/**
 * Fetches the managed package version ID from the backend.
 * Caches the result for subsequent calls.
 * 
 * @returns {Promise<void>}
 * @throws {Error} If the fetch fails
 */
export const fetchManagedPackageVersionId = async (): Promise<void> => {
    if (cachedManagedPkgVersionId) {
        return;
    }
    const response = await SFConnection.getAxiosInstance().get(CQAppConstant.MANAGED_PACKAGE_VERSION);
    
    // Cache the managed package version ID
    if (response.data?.daManagedPkgVersionId) {
        cachedManagedPkgVersionId = response.data.daManagedPkgVersionId;
    }
};

/**
 * Constructs the Salesforce managed package installation URL.
 * 
 * @param {string} baseUrl - The Salesforce base URL (production, sandbox, or custom domain).
 * @returns {string} The complete installation URL with package version ID parameter.
 * @throws {Error} If the baseUrl is malformed.
 */
export const getInstallUrl = (baseUrl: string): string => {
    try {
        const url = new URL(CQAppConstant.SF_MANAGED_PKG_INSTALL_PATH, baseUrl);
        url.searchParams.set(
            CQAppConstant.SF_MANAGED_PKG_INSTALL_QUERY_PARAM,
            cachedManagedPkgVersionId
        );
        return url.toString();
    } catch (error) {
        console.error('Failed to construct install URL:', error);
        throw new Error('Invalid URL format');
    }
};